/**
 * SendWell Klantenportaal — Vertalingen
 * Talen: NL, EN, DE, FR
 */
const translations = {
  nl: {
    // Navigatie
    nav_dashboard: 'Dashboard',
    nav_aanvragen: 'Aanvragen',
    nav_tracking: 'Track & Trace',
    nav_analytics: 'Analytics',
    nav_facturen: 'Facturen',
    nav_bordero: 'Bordero',
    nav_berichten: 'Berichten',
    nav_help: 'Help',
    nav_instellingen: 'Instellingen',
    nav_afdrukken: 'Afdrukken',
    nav_uitloggen: 'Uitloggen',

    // Algemeen
    portaalgebruiker: 'Portaalgebruiker',
    nieuwe_aanvraag: 'Nieuwe aanvraag',
    transport_inplannen: 'Transport inplannen',
    laden: 'Laden...',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    sluiten: 'Sluiten',
    bewerken: 'Bewerken',
    verwijderen: 'Verwijderen',
    downloaden: 'Downloaden',
    zoeken: 'Zoeken...',
    alles_gelezen: 'Alles gelezen',
    geen_resultaten: 'Geen resultaten',
    terug: '← Terug',

    // Status labels
    status_aanvraag_ingediend: 'Aanvraag ingediend',
    status_prijs_ontvangen: 'Prijs ontvangen',
    status_prijs_geoffreerd: 'Prijs geoffreerd',
    status_akkoord_gegeven: 'Akkoord gegeven',
    status_opdracht_ontvangen: 'Opdracht ontvangen',
    status_opdracht_verzonden: 'Opdracht verzonden',
    status_opdracht_bevestigd: 'Opdracht bevestigd',
    status_onderweg: 'Onderweg',
    status_afgeleverd: 'Afgeleverd',
    status_afgerond: 'Afgerond',
    status_factuur_verstuurd: 'Factuur verstuurd',
    status_betaald: 'Betaald',
    status_geannuleerd: 'Geannuleerd',
    status_in_behandeling: 'In behandeling',
    alle_statussen: 'Alle statussen',

    // Dashboard sectie
    dashboard_welkom: 'Goedemorgen',
    dashboard_actieve_zendingen: 'Actieve zendingen',
    dashboard_onderweg: 'onderweg',
    dashboard_openstaande_facturen: 'Openstaande facturen',
    dashboard_ongelezen_berichten: 'Ongelezen berichten',
    dashboard_recente_activiteit: 'Recente activiteit',
    dashboard_alles_in_orde: 'Alles in orde',
    dashboard_kosten_routes: 'Kosten & routes',

    // Aanvragen
    aanvraag: 'Aanvraag',
    aanvragen_overzicht: 'Overzicht van al uw transportopdrachten',
    datum: 'Datum',
    bestemming: 'Bestemming',
    goederen: 'Goederen',
    laaddatum: 'Laaddatum',
    losdatum: 'Losdatum',
    status: 'Status',
    actie: 'Actie',
    route: 'Route',
    prijs: 'Prijs',
    totaal: 'Totaal',
    klant: 'Klant',
    onbekend: 'Onbekend',
    hub_bereikt: 'Hub bereikt',
    hub_verlaten: 'Hub verlaten',

    // Facturen
    facturen_overzicht: 'Financieel overzicht van uw account',
    factuurnr: 'Factuurnr',
    factuurdatum: 'Factuurdatum',
    vervaldatum: 'Vervaldatum',
    openstaand: 'Openstaand',
    betaald: 'Betaald',
    factuur_niet_beschikbaar: 'Factuur PDF niet beschikbaar.',
    fout_ophalen_factuur: 'Fout bij ophalen factuur.',
    facturen: 'facturen',
    facturen_weergegeven: 'facturen weergegeven',
    verloopt_over: 'Verloopt over',
    dgn: 'dgn',
    te_laat: 'dgn te laat',

    // Bordero
    zendingdossier: 'Zendingdossier',
    tijdlijn: 'Tijdlijn',
    route_gps: 'Route & GPS',
    communicatie: 'Communicatie',
    documenten: 'Documenten',
    factuur: 'Factuur',
    geen_tracker: 'Geen tracker gekoppeld aan deze zending.',
    geen_gps: 'Geen GPS-posities beschikbaar.',
    gps_laden: 'GPS data laden...',
    dossier_laden: 'Dossier laden...',
    geen_events: 'Nog geen events voor deze zending.',
    geen_bijlagen: 'Geen bijlagen beschikbaar voor deze zending.',
    geen_communicatie: 'Geen communicatie gevonden voor deze zending.',
    geen_documenten: 'Geen documenten beschikbaar voor deze zending.',
    geen_factuur: 'Nog geen factuur beschikbaar voor deze zending.',
    afdrukken: 'Print',
    verversen: 'Verversen',
    huidige_positie: 'Huidige positie',
    zendingdossiers: 'Zendingdossiers',
    zendingdossiers_sub: 'Volledige historie, documenten en tijdlijn per zending',
    proof_of_delivery: 'Proof of Delivery',
    succesvol_afgeleverd: '✓ Zending succesvol afgeleverd',
    cmr_document: 'CMR-vrachtbrief',

    // Track & Trace
    live_tracking: 'Live Tracking',
    actieve_zendingen: 'actieve zendingen',
    zendingen: 'Zendingen',
    klik_op_kaart: 'Klik op kaart te tonen',
    alle_bestemmingen: 'Alle bestemmingen',
    laatste_update: 'Laatste update',
    meer_info: '▼ Meer info',
    minder_info: '▲ Minder info',
    live: 'LIVE',

    // Berichten
    nieuw_bericht: 'Nieuw bericht',
    klik_om_te_lezen: 'Klik om te lezen',

    // Instellingen
    instellingen: 'Instellingen',
    bedrijfslogo: 'Bedrijfslogo voor documenten',
    logo_sub: 'Dit logo verschijnt op alle afgedrukte documenten en rapporten.',
    logo_uploaden: 'Logo uploaden',
    ander_logo: 'Ander logo kiezen',
    logo_opgeslagen: '✓ Logo opgeslagen — zichtbaar op alle documenten',
    nog_geen_logo: 'Nog geen logo geüpload',
    account: 'Account',
    gebruikersnaam: 'Gebruikersnaam',
    wachtwoord_wijzigen: 'Wachtwoord wijzigen',
    huidig_wachtwoord: 'Huidig wachtwoord',
    nieuw_wachtwoord: 'Nieuw wachtwoord',
    bevestig_wachtwoord: 'Bevestig wachtwoord',

    // Login
    login_welkom: 'Welkom bij het SendWell Klantenportaal',
    login_sub: 'Log in om uw zendingen te beheren',
    inloggen: 'Inloggen',
    inloggen_bezig: 'Inloggen...',

    // Taal
    taal: 'Taal',
    taal_nl: 'Nederlands',
    taal_en: 'English',
    taal_de: 'Deutsch',
    taal_fr: 'Français',
    login_gebruikersnaam: 'Votre nom d\'utilisateur',
    login_wachtwoord: 'Mot de passe',
    login_onthoud: 'Se souvenir de moi',
    login_contact: 'Nous contacter',
    login_admin: '← Retour connexion admin',
    klanten_portal: 'Portail client',
    laadplaats: 'Lieu de chargement',
    losplaats: 'Lieu de livraison',
    aanvraagdatum: 'Date de demande',
    factuurnummer: 'Numéro de facture',
    referentie: 'Référence',
    opmerkingen: 'Remarques',
    specialiteiten: 'Exigences spéciales',
    overzicht: 'Aperçu',
    tracker: 'Tracker',
    geen_goederen: 'Aucune marchandise spécifiée',
    klik_factuur: 'Cliquer pour voir la facture',
    prijs_excl_btw: 'Prix (hors TVA)',
    akkoord_geven: 'Approuver',
    kopieer_aanvraag: 'Copier la demande',
    geen_aanvragen: 'Aucune expédition trouvée',
    klik_details: 'Cliquer pour les détails',
    aantal: 'Quantité',
    omschrijving: 'Description',
    gewicht: 'Poids',
    afmetingen: 'Dimensions',
    lossen: 'Déchargement',
    bezig: 'En cours...',
    berichten_titel: 'Messages',
    chat_team: 'Discutez avec notre équipe',
    typ_bericht: 'Tapez un message... (Entrée pour envoyer)',
    foto_toevoegen: 'Ajouter photo',
    online: 'En ligne',
    algemeen: 'Général',
    betreft: 'Objet:',
    analytics_titel: 'Analytique',
    nog_geen_data: 'Aucune donnée disponible',
    status_zendingen: 'Statut de toutes les expéditions',
    zendingen_per_land: 'Expéditions par pays',
    kosten_route: 'Coûts par route',
    kosten_bestemming: 'Coûts par destination',
    meest_routes: 'Routes les plus utilisées',
    goederensoorten: 'Types de marchandises',
    kostenverdeling: '💰 Répartition des coûts',
    trends_periode: '📈 Tendances par période',
    volumeverdeling: '📦 Répartition des volumes',
    status_gewicht: '🔄 Statut et poids',
    basis_gegevens: 'Données de base',
    overige_gegevens: 'Autres données',
    factuuradres: 'Adresse de facturation',
    bedrijfsnaam: 'Nom de l\'entreprise',
    adres: 'Adresse',
    postcode: 'Code postal',
    plaats: 'Ville',
    land: 'Pays',
    telefoon: 'Téléphone',
    website: 'Site web',
    contactpersoon: 'Personne de contact',
    rekeningnummer: 'Numéro de compte',
    kvk_nr: 'N° de registre',
    btw_nr: 'N° TVA',
    btw_tarief: 'Taux TVA',
    bewerkmodus: 'Mode édition actif',
    herhaal_wachtwoord: 'Répéter mot de passe',
    min_8_chars: 'Min. 8 caractères',
    prijsopgave: 'Devis',
    prijs_niet_beschikbaar: 'Prix pas encore disponible',
    ontvangen_door: 'Reçu par',
    cmr_nummer: 'Numéro CMR',

    login_gebruikersnaam: 'Jouw gebruikersnaam',
    login_wachtwoord: 'Wachtwoord',
    login_onthoud: 'Onthoud mij',
    login_contact: 'Neem contact op',
    login_admin: '← Terug naar admin login',
    klanten_portal: 'Klantenportaal',
    laadplaats: 'Laadplaats',
    losplaats: 'Losplaats',
    aanvraagdatum: 'Aanvraagdatum',
    factuurnummer: 'Factuurnummer',
    referentie: 'Referentie',
    opmerkingen: 'Opmerkingen',
    specialiteiten: 'Specialiteiten',
    overzicht: 'Overzicht',
    tracker: 'Tracker',
    geen_goederen: 'Geen goederen opgegeven',
    klik_factuur: 'Klik om factuur te bekijken',
    prijs_excl_btw: 'Prijs (excl. BTW)',
    akkoord_geven: 'Akkoord geven',
    kopieer_aanvraag: 'Kopieer aanvraag',
    geen_aanvragen: 'Geen aanvragen gevonden',
    klik_details: 'Klik voor details',
    aantal: 'Aantal',
    omschrijving: 'Omschrijving',
    gewicht: 'Gewicht',
    afmetingen: 'Afmetingen',
    lossen: 'Lossen',
    bezig: 'Bezig...',
    berichten_titel: 'Berichten',
    chat_team: 'Chat met ons team',
    typ_bericht: 'Typ een bericht... (Enter om te versturen)',
    foto_toevoegen: 'Foto toevoegen',
    online: 'Online',
    algemeen: 'Algemeen',
    betreft: 'Betreft:',
    analytics_titel: 'Analytics',
    nog_geen_data: 'Nog geen data beschikbaar',
    status_zendingen: 'Status alle zendingen',
    zendingen_per_land: 'Zendingen per land',
    kosten_route: 'Kosten per route',
    kosten_bestemming: 'Kosten per bestemming',
    meest_routes: 'Meest gebruikte routes',
    goederensoorten: 'Goederensoorten',
    kostenverdeling: '💰 Kostenverdeling',
    trends_periode: '📈 Trends per periode',
    volumeverdeling: '📦 Volumeverdeling',
    status_gewicht: '🔄 Status en gewicht',
    basis_gegevens: 'Basis gegevens',
    overige_gegevens: 'Overige gegevens',
    factuuradres: 'Factuuradres',
    bedrijfsnaam: 'Bedrijfsnaam',
    adres: 'Adres',
    postcode: 'Postcode',
    plaats: 'Plaats',
    land: 'Land',
    telefoon: 'Telefoon',
    website: 'Website',
    contactpersoon: 'Contactpersoon',
    rekeningnummer: 'Rekeningnummer',
    kvk_nr: 'KvK nr',
    btw_nr: 'BTW/VAT nr',
    btw_tarief: 'BTW tarief',
    bewerkmodus: 'Bewerkmodus actief',
    herhaal_wachtwoord: 'Herhaal wachtwoord',
    min_8_chars: 'Min. 8 karakters',
    prijsopgave: 'Prijsopgave',
    prijs_niet_beschikbaar: 'Prijs nog niet beschikbaar',
    ontvangen_door: 'Ontvangen door',
    cmr_nummer: 'CMR nummer',
    // Berichten
    gisteren: 'Gisteren',
    nav_vaste_zendingen: 'Vaste zendingen',
    herhaal: 'Herhaal', herhaal_zending: 'Zending herhalen',
    herhaal_prefilled: "Ingevuld op basis van eerdere zending — pas aan waar nodig.",
    ja_btn: 'Ja', nee_btn: 'Nee',
    help_hero_titel: 'Hoe kunnen we u helpen?',
    help_hero_sub: 'Doorzoek onze kennisbank of browse door de categorieën.',
    help_zoek_placeholder: 'Zoek op onderwerp...',
    help_bladeren: 'Bladeren op categorie',
    help_populair: '📌 Populaire artikelen',
    help_aanvraag: 'Aanvraag indienen',
    help_s_aanvraag: 'Hoe dient u een nieuwe transportaanvraag in?',
    help_tracking: 'Zending volgen',
    help_s_tracking: 'Live GPS tracking en routegeschiedenis',
    help_berichten: 'Berichten & communicatie',
    help_s_berichten: 'Communiceer met SendWell via het portaal',
    help_documenten: 'Documenten & facturen',
    help_s_documenten: 'Offertes, bevestigingen en facturen inzien',
    help_account: 'Uw account',
    help_s_account: 'Inloggen, wachtwoord en accountbeheer',
    help_faq: 'Veelgestelde vragen',
    help_s_faq: 'Snel antwoord op veelgestelde vragen',
    help_nuttig: 'Was dit artikel behulpzaam?',
    help_geen_resultaten: 'Probeer andere zoektermen',
    help_contact: 'Neem contact op met SendWell',
    help_niet_gevonden: 'Antwoord niet gevonden?',
    cht_taart: 'Taart', cht_donut: 'Donut', cht_balk: 'Balk',
    dashboard_welkom_middag: 'Goedemiddag',
    dashboard_welkom_avond: 'Goedenavond',
    dashboard_hier_overzicht: 'Hier is uw overzicht voor',
    dashboard_afgerond_dit_jaar: 'Afgerond dit jaar',
    verstuur: 'Verstuur',
    geen_berichten_aanvraag: 'Geen berichten voor deze aanvraag',
    geen_berichten_nog: 'Nog geen berichten',
    filter_tip: 'Kies "Algemeen" om alle berichten te zien',
    start_gesprek: 'Stuur een bericht om het gesprek te starten',

    // Analytics uitgebreid
    analytics_totale_kosten: 'Totale kosten',
    analytics_gem_zending: 'Gem. per zending',
    analytics_totaal_gewicht: 'Totaal gewicht',
    analytics_gem_doorlooptijd: 'Gem. doorlooptijd',
    zendingen_dit_jaar: 'zendingen dit jaar',
    momenteel_onderweg: 'momenteel onderweg',
    geen_actieve_zendingen: 'Geen actieve zendingen',
    gem_per_transport: 'Gemiddeld per transport',
    geen_colli_data: 'Geen colli data',
    laad_los_datum: 'Laaddatum → losdatum',
    analytics_geen_kosten: 'Nog geen kostendata beschikbaar',
    analytics_geen_gewicht: 'Nog geen gewichtdata beschikbaar',
    gewicht_per_maand: 'Gewicht per maand (kg)',
    analytics_op_losland: 'Op basis van losland',
    analytics_laad_los_combo: 'Laad → Los combinaties',
    analytics_aantal_bestemming: 'Aantal per bestemming',
    analytics_aantal_route: 'Aantal per route',
    analytics_wat_vervoert: 'Wat vervoert u het meest',
    analytisch_categorieren: 'categorieën',
    periode_maand: 'Maand', periode_kwartaal: 'Kwartaal', periode_jaar: 'Jaar',
    kleurenpalet: 'Kleurenpalet',
    pal_oceaan: 'Oceaan', pal_zonsondergang: 'Zonsondergang',
    pal_bos: 'Bos', pal_paars: 'Paars', pal_contrast: 'Hoog contrast',
    maand_jan: 'jan', maand_feb: 'feb', maand_mrt: 'mrt', maand_apr: 'apr',
    maand_mei: 'mei', maand_jun: 'jun', maand_jul: 'jul', maand_aug: 'aug',
    maand_sep: 'sep', maand_okt: 'okt', maand_nov: 'nov', maand_dec: 'dec',

    // Dashboard
    wacht_op_bevestiging: 'Wacht op bevestiging',
    geen_facturen_gevonden: 'Geen facturen gevonden',
    logistiek: 'Logistiek', administratie: 'Administratie',
    communicatie_sub: 'Directe communicatie met SendWell',
    help_sub: 'Antwoorden op veelgestelde vragen',
    lopende_aanvragen: 'Lopende aanvragen',
    soort: 'Soort', reden: 'Reden',

  },

  en: {
    nav_dashboard: 'Dashboard',
    nav_aanvragen: 'Shipments',
    nav_tracking: 'Track & Trace',
    nav_analytics: 'Analytics',
    nav_facturen: 'Invoices',
    nav_bordero: 'Dossier',
    nav_berichten: 'Messages',
    nav_help: 'Help',
    nav_instellingen: 'Settings',
    nav_afdrukken: 'Print',
    nav_uitloggen: 'Log out',

    portaalgebruiker: 'Portal user',
    nieuwe_aanvraag: 'New shipment',
    transport_inplannen: 'Schedule transport',
    laden: 'Loading...',
    opslaan: 'Save',
    annuleren: 'Cancel',
    sluiten: 'Close',
    bewerken: 'Edit',
    verwijderen: 'Delete',
    downloaden: 'Download',
    zoeken: 'Search...',
    alles_gelezen: 'Mark all read',
    geen_resultaten: 'No results',
    terug: '← Back',

    status_aanvraag_ingediend: 'Request submitted',
    status_prijs_ontvangen: 'Price received',
    status_prijs_geoffreerd: 'Price quoted',
    status_akkoord_gegeven: 'Approved',
    status_opdracht_ontvangen: 'Order received',
    status_opdracht_verzonden: 'Order sent',
    status_opdracht_bevestigd: 'Order confirmed',
    status_onderweg: 'In transit',
    status_afgeleverd: 'Delivered',
    status_afgerond: 'Completed',
    status_factuur_verstuurd: 'Invoice sent',
    status_betaald: 'Paid',
    status_geannuleerd: 'Cancelled',
    status_in_behandeling: 'In progress',
    alle_statussen: 'All statuses',

    dashboard_welkom: 'Good morning',
    dashboard_actieve_zendingen: 'Active shipments',
    dashboard_onderweg: 'in transit',
    dashboard_openstaande_facturen: 'Outstanding invoices',
    dashboard_ongelezen_berichten: 'Unread messages',
    dashboard_recente_activiteit: 'Recent activity',
    dashboard_alles_in_orde: 'All clear',
    dashboard_kosten_routes: 'Costs & routes',

    aanvraag: 'Shipment',
    aanvragen_overzicht: 'Overview of all your transport orders',
    datum: 'Date',
    bestemming: 'Destination',
    goederen: 'Goods',
    laaddatum: 'Loading date',
    losdatum: 'Delivery date',
    status: 'Status',
    actie: 'Action',
    route: 'Route',
    prijs: 'Price',
    totaal: 'Total',
    klant: 'Client',
    onbekend: 'Unknown',
    hub_bereikt: 'Hub reached',
    hub_verlaten: 'Hub departed',

    facturen_overzicht: 'Financial overview of your account',
    factuurnr: 'Invoice no.',
    factuurdatum: 'Invoice date',
    vervaldatum: 'Due date',
    openstaand: 'Outstanding',
    betaald: 'Paid',
    factuur_niet_beschikbaar: 'Invoice PDF not available.',
    fout_ophalen_factuur: 'Error retrieving invoice.',
    facturen: 'invoices',
    facturen_weergegeven: 'invoices shown',
    verloopt_over: 'Due in',
    dgn: 'days',
    te_laat: 'days overdue',

    zendingdossier: 'Shipment dossier',
    tijdlijn: 'Timeline',
    route_gps: 'Route & GPS',
    communicatie: 'Communication',
    documenten: 'Documents',
    factuur: 'Invoice',
    geen_tracker: 'No tracker linked to this shipment.',
    geen_gps: 'No GPS positions available.',
    gps_laden: 'Loading GPS data...',
    dossier_laden: 'Loading dossier...',
    geen_events: 'No events recorded for this shipment.',
    geen_bijlagen: 'No attachments available for this shipment.',
    geen_communicatie: 'No communication found for this shipment.',
    geen_documenten: 'No documents available for this shipment.',
    geen_factuur: 'No invoice available yet for this shipment.',
    afdrukken: 'Print',
    verversen: 'Refresh',
    huidige_positie: 'Current position',
    zendingdossiers: 'Shipment dossiers',
    zendingdossiers_sub: 'Full history, documents and timeline per shipment',
    proof_of_delivery: 'Proof of Delivery',
    succesvol_afgeleverd: '✓ Shipment successfully delivered',
    cmr_document: 'CMR waybill',

    live_tracking: 'Live Tracking',
    actieve_zendingen: 'active shipments',
    zendingen: 'Shipments',
    klik_op_kaart: 'Click on map to show',
    alle_bestemmingen: 'All destinations',
    laatste_update: 'Last update',
    meer_info: '▼ More info',
    minder_info: '▲ Less info',
    live: 'LIVE',

    nieuw_bericht: 'New message',
    klik_om_te_lezen: 'Click to read',

    instellingen: 'Settings',
    bedrijfslogo: 'Company logo for documents',
    logo_sub: 'This logo appears on all printed documents and reports.',
    logo_uploaden: 'Upload logo',
    ander_logo: 'Choose different logo',
    logo_opgeslagen: '✓ Logo saved — visible on all documents',
    nog_geen_logo: 'No logo uploaded yet',
    account: 'Account',
    gebruikersnaam: 'Username',
    wachtwoord_wijzigen: 'Change password',
    huidig_wachtwoord: 'Current password',
    nieuw_wachtwoord: 'New password',
    bevestig_wachtwoord: 'Confirm password',

    login_welkom: 'Welcome to the SendWell Customer Portal',
    login_sub: 'Log in to manage your shipments',
    inloggen: 'Log in',
    inloggen_bezig: 'Logging in...',

    taal: 'Language',
    taal_nl: 'Dutch',
    taal_en: 'English',
    taal_de: 'German',
    taal_fr: 'French',
    login_gebruikersnaam: 'Your username',
    login_wachtwoord: 'Password',
    login_onthoud: 'Remember me',
    login_contact: 'Contact us',
    login_admin: '← Back to admin login',
    klanten_portal: 'Customer Portal',
    laadplaats: 'Loading location',
    losplaats: 'Delivery location',
    aanvraagdatum: 'Request date',
    factuurnummer: 'Invoice number',
    referentie: 'Reference',
    opmerkingen: 'Remarks',
    specialiteiten: 'Special requirements',
    overzicht: 'Overview',
    tracker: 'Tracker',
    geen_goederen: 'No goods specified',
    klik_factuur: 'Click to view invoice',
    prijs_excl_btw: 'Price (excl. VAT)',
    akkoord_geven: 'Approve',
    kopieer_aanvraag: 'Copy shipment',
    geen_aanvragen: 'No shipments found',
    klik_details: 'Click for details',
    aantal: 'Quantity',
    omschrijving: 'Description',
    gewicht: 'Weight',
    afmetingen: 'Dimensions',
    lossen: 'Unloading',
    bezig: 'Processing...',
    berichten_titel: 'Messages',
    chat_team: 'Chat with our team',
    typ_bericht: 'Type a message... (Enter to send)',
    foto_toevoegen: 'Add photo',
    online: 'Online',
    algemeen: 'General',
    betreft: 'Subject:',
    analytics_titel: 'Analytics',
    nog_geen_data: 'No data available yet',
    status_zendingen: 'Status all shipments',
    zendingen_per_land: 'Shipments per country',
    kosten_route: 'Costs per route',
    kosten_bestemming: 'Costs per destination',
    meest_routes: 'Most used routes',
    goederensoorten: 'Goods types',
    kostenverdeling: '💰 Cost breakdown',
    trends_periode: '📈 Trends per period',
    volumeverdeling: '📦 Volume breakdown',
    status_gewicht: '🔄 Status and weight',
    basis_gegevens: 'Basic details',
    overige_gegevens: 'Other details',
    factuuradres: 'Invoice address',
    bedrijfsnaam: 'Company name',
    adres: 'Address',
    postcode: 'Postal code',
    plaats: 'City',
    land: 'Country',
    telefoon: 'Phone',
    website: 'Website',
    contactpersoon: 'Contact person',
    rekeningnummer: 'Bank account',
    kvk_nr: 'Chamber of Commerce',
    btw_nr: 'VAT number',
    btw_tarief: 'VAT rate',
    bewerkmodus: 'Edit mode active',
    herhaal_wachtwoord: 'Repeat password',
    min_8_chars: 'Min. 8 characters',
    prijsopgave: 'Price quote',
    prijs_niet_beschikbaar: 'Price not yet available',
    ontvangen_door: 'Received by',
    cmr_nummer: 'CMR number',
    // Messages
    gisteren: 'Yesterday',
    nav_vaste_zendingen: 'Recurring shipments',
    herhaal: 'Repeat', herhaal_zending: 'Repeat shipment',
    herhaal_prefilled: "Pre-filled based on a previous shipment — adjust where needed.",
    ja_btn: 'Yes', nee_btn: 'No',
    help_hero_titel: 'How can we help you?',
    help_hero_sub: 'Search our knowledge base or browse the categories.',
    help_zoek_placeholder: 'Search by topic...',
    help_bladeren: 'Browse by category',
    help_populair: '📌 Popular articles',
    help_aanvraag: 'Submit a request',
    help_s_aanvraag: 'How to submit a new transport request',
    help_tracking: 'Track your shipment',
    help_s_tracking: 'Live GPS tracking and route history',
    help_berichten: 'Messages & communication',
    help_s_berichten: 'Communicate with SendWell via the portal',
    help_documenten: 'Documents & invoices',
    help_s_documenten: 'View quotes, confirmations and invoices',
    help_account: 'Your account',
    help_s_account: 'Login, password and account management',
    help_faq: 'Frequently asked questions',
    help_s_faq: 'Quick answers to common questions',
    help_nuttig: 'Was this article helpful?',
    help_geen_resultaten: 'Try different search terms',
    help_contact: 'Contact SendWell',
    help_niet_gevonden: 'Answer not found?',
    cht_taart: 'Pie', cht_donut: 'Donut', cht_balk: 'Bar',
    dashboard_welkom_middag: 'Good afternoon',
    dashboard_welkom_avond: 'Good evening',
    dashboard_hier_overzicht: 'Here is your overview for',
    dashboard_afgerond_dit_jaar: 'Completed this year',
    verstuur: 'Send',
    geen_berichten_aanvraag: 'No messages for this shipment',
    geen_berichten_nog: 'No messages yet',
    filter_tip: 'Select "General" to see all messages',
    start_gesprek: 'Send a message to start the conversation',

    // Analytics extended
    analytics_totale_kosten: 'Total costs',
    analytics_gem_zending: 'Avg. per shipment',
    analytics_totaal_gewicht: 'Total weight',
    analytics_gem_doorlooptijd: 'Avg. lead time',
    zendingen_dit_jaar: 'shipments this year',
    momenteel_onderweg: 'currently in transit',
    geen_actieve_zendingen: 'No active shipments',
    gem_per_transport: 'Average per transport',
    geen_colli_data: 'No package data',
    laad_los_datum: 'Loading date → delivery date',
    analytics_geen_kosten: 'No cost data available yet',
    analytics_geen_gewicht: 'No weight data available yet',
    gewicht_per_maand: 'Weight per month (kg)',
    analytics_op_losland: 'Based on delivery country',
    analytics_laad_los_combo: 'Load → Delivery combinations',
    analytics_aantal_bestemming: 'Count per destination',
    analytics_aantal_route: 'Count per route',
    analytics_wat_vervoert: 'What do you ship most',
    analytisch_categorieren: 'categories',
    periode_maand: 'Month', periode_kwartaal: 'Quarter', periode_jaar: 'Year',
    kleurenpalet: 'Color palette',
    pal_oceaan: 'Ocean', pal_zonsondergang: 'Sunset',
    pal_bos: 'Forest', pal_paars: 'Purple', pal_contrast: 'High contrast',
    maand_jan: 'Jan', maand_feb: 'Feb', maand_mrt: 'Mar', maand_apr: 'Apr',
    maand_mei: 'May', maand_jun: 'Jun', maand_jul: 'Jul', maand_aug: 'Aug',
    maand_sep: 'Sep', maand_okt: 'Oct', maand_nov: 'Nov', maand_dec: 'Dec',

    // Dashboard
    wacht_op_bevestiging: 'Awaiting confirmation',
    geen_facturen_gevonden: 'No invoices found',
    logistiek: 'Logistics', administratie: 'Administration',
    communicatie_sub: 'Direct communication with SendWell',
    help_sub: 'Answers to frequently asked questions',
    lopende_aanvragen: 'Active shipments',
    soort: 'Type', reden: 'Reason',

  },

  de: {
    nav_dashboard: 'Dashboard',
    nav_aanvragen: 'Sendungen',
    nav_tracking: 'Track & Trace',
    nav_analytics: 'Analytik',
    nav_facturen: 'Rechnungen',
    nav_bordero: 'Dossier',
    nav_berichten: 'Nachrichten',
    nav_help: 'Hilfe',
    nav_instellingen: 'Einstellungen',
    nav_afdrukken: 'Drucken',
    nav_uitloggen: 'Abmelden',

    portaalgebruiker: 'Portalbenutzer',
    nieuwe_aanvraag: 'Neue Sendung',
    transport_inplannen: 'Transport planen',
    laden: 'Laden...',
    opslaan: 'Speichern',
    annuleren: 'Abbrechen',
    sluiten: 'Schließen',
    bewerken: 'Bearbeiten',
    verwijderen: 'Löschen',
    downloaden: 'Herunterladen',
    zoeken: 'Suchen...',
    alles_gelezen: 'Alle gelesen',
    geen_resultaten: 'Keine Ergebnisse',
    terug: '← Zurück',

    status_aanvraag_ingediend: 'Anfrage eingereicht',
    status_prijs_ontvangen: 'Preis erhalten',
    status_prijs_geoffreerd: 'Preis angeboten',
    status_akkoord_gegeven: 'Genehmigt',
    status_opdracht_ontvangen: 'Auftrag erhalten',
    status_opdracht_verzonden: 'Auftrag gesendet',
    status_opdracht_bevestigd: 'Auftrag bestätigt',
    status_onderweg: 'Unterwegs',
    status_afgeleverd: 'Geliefert',
    status_afgerond: 'Abgeschlossen',
    status_factuur_verstuurd: 'Rechnung gesendet',
    status_betaald: 'Bezahlt',
    status_geannuleerd: 'Storniert',
    status_in_behandeling: 'In Bearbeitung',
    alle_statussen: 'Alle Status',

    dashboard_welkom: 'Guten Morgen',
    dashboard_actieve_zendingen: 'Aktive Sendungen',
    dashboard_onderweg: 'unterwegs',
    dashboard_openstaande_facturen: 'Offene Rechnungen',
    dashboard_ongelezen_berichten: 'Ungelesene Nachrichten',
    dashboard_recente_activiteit: 'Letzte Aktivität',
    dashboard_alles_in_orde: 'Alles in Ordnung',
    dashboard_kosten_routes: 'Kosten & Routen',

    aanvraag: 'Sendung',
    aanvragen_overzicht: 'Übersicht aller Ihrer Transportaufträge',
    datum: 'Datum',
    bestemming: 'Ziel',
    goederen: 'Waren',
    laaddatum: 'Beladedatum',
    losdatum: 'Lieferdatum',
    status: 'Status',
    actie: 'Aktion',
    route: 'Route',
    prijs: 'Preis',
    totaal: 'Gesamt',
    klant: 'Kunde',
    onbekend: 'Unbekannt',
    hub_bereikt: 'Hub erreicht',
    hub_verlaten: 'Hub verlassen',

    facturen_overzicht: 'Finanzübersicht Ihres Kontos',
    factuurnr: 'Rechnungsnr.',
    factuurdatum: 'Rechnungsdatum',
    vervaldatum: 'Fälligkeitsdatum',
    openstaand: 'Ausstehend',
    betaald: 'Bezahlt',
    factuur_niet_beschikbaar: 'Rechnung PDF nicht verfügbar.',
    fout_ophalen_factuur: 'Fehler beim Abrufen der Rechnung.',
    facturen: 'Rechnungen',
    facturen_weergegeven: 'Rechnungen angezeigt',
    verloopt_over: 'Fällig in',
    dgn: 'Tage',
    te_laat: 'Tage überfällig',

    zendingdossier: 'Sendungsakte',
    tijdlijn: 'Zeitverlauf',
    route_gps: 'Route & GPS',
    communicatie: 'Kommunikation',
    documenten: 'Dokumente',
    factuur: 'Rechnung',
    geen_tracker: 'Kein Tracker mit dieser Sendung verknüpft.',
    geen_gps: 'Keine GPS-Positionen verfügbar.',
    gps_laden: 'GPS-Daten laden...',
    dossier_laden: 'Akte laden...',
    geen_events: 'Noch keine Ereignisse für diese Sendung.',
    geen_bijlagen: 'Keine Anhänge für diese Sendung verfügbar.',
    geen_communicatie: 'Keine Kommunikation für diese Sendung gefunden.',
    geen_documenten: 'Keine Dokumente für diese Sendung verfügbar.',
    geen_factuur: 'Noch keine Rechnung für diese Sendung verfügbar.',
    afdrukken: 'Drucken',
    verversen: 'Aktualisieren',
    huidige_positie: 'Aktuelle Position',
    zendingdossiers: 'Sendungsakten',
    zendingdossiers_sub: 'Vollständige Historie, Dokumente und Zeitverlauf pro Sendung',
    proof_of_delivery: 'Liefernachweis',
    succesvol_afgeleverd: '✓ Sendung erfolgreich zugestellt',
    cmr_document: 'CMR-Frachtbrief',

    live_tracking: 'Live-Tracking',
    actieve_zendingen: 'aktive Sendungen',
    zendingen: 'Sendungen',
    klik_op_kaart: 'Auf Karte klicken zum Anzeigen',
    alle_bestemmingen: 'Alle Ziele',
    laatste_update: 'Letzte Aktualisierung',
    meer_info: '▼ Mehr Info',
    minder_info: '▲ Weniger Info',
    live: 'LIVE',

    nieuw_bericht: 'Neue Nachricht',
    klik_om_te_lezen: 'Zum Lesen klicken',

    instellingen: 'Einstellungen',
    bedrijfslogo: 'Firmenlogo für Dokumente',
    logo_sub: 'Dieses Logo erscheint auf allen gedruckten Dokumenten und Berichten.',
    logo_uploaden: 'Logo hochladen',
    ander_logo: 'Anderes Logo wählen',
    logo_opgeslagen: '✓ Logo gespeichert — sichtbar auf allen Dokumenten',
    nog_geen_logo: 'Noch kein Logo hochgeladen',
    account: 'Konto',
    gebruikersnaam: 'Benutzername',
    wachtwoord_wijzigen: 'Passwort ändern',
    huidig_wachtwoord: 'Aktuelles Passwort',
    nieuw_wachtwoord: 'Neues Passwort',
    bevestig_wachtwoord: 'Passwort bestätigen',

    login_welkom: 'Willkommen im SendWell Kundenportal',
    login_sub: 'Melden Sie sich an, um Ihre Sendungen zu verwalten',
    inloggen: 'Anmelden',
    inloggen_bezig: 'Anmelden...',

    taal: 'Sprache',
    taal_nl: 'Niederländisch',
    taal_en: 'Englisch',
    taal_de: 'Deutsch',
    taal_fr: 'Französisch',
    login_gebruikersnaam: 'Ihr Benutzername',
    login_wachtwoord: 'Passwort',
    login_onthoud: 'Angemeldet bleiben',
    login_contact: 'Kontakt aufnehmen',
    login_admin: '← Zurück zur Admin-Anmeldung',
    klanten_portal: 'Kundenportal',
    laadplaats: 'Ladeort',
    losplaats: 'Entladeort',
    aanvraagdatum: 'Anfragedatum',
    factuurnummer: 'Rechnungsnummer',
    referentie: 'Referenz',
    opmerkingen: 'Bemerkungen',
    specialiteiten: 'Besonderheiten',
    overzicht: 'Übersicht',
    tracker: 'Tracker',
    geen_goederen: 'Keine Waren angegeben',
    klik_factuur: 'Klicken Sie, um die Rechnung anzuzeigen',
    prijs_excl_btw: 'Preis (exkl. MwSt.)',
    akkoord_geven: 'Genehmigen',
    kopieer_aanvraag: 'Auftrag kopieren',
    geen_aanvragen: 'Keine Sendungen gefunden',
    klik_details: 'Für Details klicken',
    aantal: 'Anzahl',
    omschrijving: 'Beschreibung',
    gewicht: 'Gewicht',
    afmetingen: 'Abmessungen',
    lossen: 'Entladen',
    bezig: 'Wird verarbeitet...',
    berichten_titel: 'Nachrichten',
    chat_team: 'Chat mit unserem Team',
    typ_bericht: 'Nachricht eingeben... (Enter zum Senden)',
    foto_toevoegen: 'Foto hinzufügen',
    online: 'Online',
    algemeen: 'Allgemein',
    betreft: 'Betreff:',
    analytics_titel: 'Analytik',
    nog_geen_data: 'Noch keine Daten verfügbar',
    status_zendingen: 'Status aller Sendungen',
    zendingen_per_land: 'Sendungen pro Land',
    kosten_route: 'Kosten pro Route',
    kosten_bestemming: 'Kosten pro Ziel',
    meest_routes: 'Meistgenutzte Routen',
    goederensoorten: 'Warenarten',
    kostenverdeling: '💰 Kostenverteilung',
    trends_periode: '📈 Trends pro Zeitraum',
    volumeverdeling: '📦 Volumenverteilung',
    status_gewicht: '🔄 Status und Gewicht',
    basis_gegevens: 'Grunddaten',
    overige_gegevens: 'Weitere Daten',
    factuuradres: 'Rechnungsadresse',
    bedrijfsnaam: 'Firmenname',
    adres: 'Adresse',
    postcode: 'Postleitzahl',
    plaats: 'Stadt',
    land: 'Land',
    telefoon: 'Telefon',
    website: 'Website',
    contactpersoon: 'Ansprechpartner',
    rekeningnummer: 'Kontonummer',
    kvk_nr: 'Handelsregister-Nr.',
    btw_nr: 'MwSt-Nr.',
    btw_tarief: 'MwSt-Satz',
    bewerkmodus: 'Bearbeitungsmodus aktiv',
    herhaal_wachtwoord: 'Passwort wiederholen',
    min_8_chars: 'Mind. 8 Zeichen',
    prijsopgave: 'Preisangebot',
    prijs_niet_beschikbaar: 'Preis noch nicht verfügbar',
    ontvangen_door: 'Empfangen von',
    cmr_nummer: 'CMR-Nummer',
    // Nachrichten
    gisteren: 'Gestern',
    nav_vaste_zendingen: 'Feste Sendungen',
    herhaal: 'Wiederholen', herhaal_zending: 'Sendung wiederholen',
    herhaal_prefilled: "Vorausgefüllt auf Basis einer früheren Sendung — bei Bedarf anpassen.",
    ja_btn: 'Ja', nee_btn: 'Nein',
    help_hero_titel: 'Wie können wir Ihnen helfen?',
    help_hero_sub: 'Durchsuchen Sie unsere Wissensdatenbank oder stöbern Sie durch die Kategorien.',
    help_zoek_placeholder: 'Nach Thema suchen...',
    help_bladeren: 'Nach Kategorie durchsuchen',
    help_populair: '📌 Beliebte Artikel',
    help_aanvraag: 'Anfrage stellen',
    help_s_aanvraag: 'Wie stellen Sie eine neue Transportanfrage?',
    help_tracking: 'Sendung verfolgen',
    help_s_tracking: 'Live GPS-Tracking und Routenhistorie',
    help_berichten: 'Nachrichten & Kommunikation',
    help_s_berichten: 'Mit SendWell über das Portal kommunizieren',
    help_documenten: 'Dokumente & Rechnungen',
    help_s_documenten: 'Angebote, Bestätigungen und Rechnungen einsehen',
    help_account: 'Ihr Konto',
    help_s_account: 'Anmelden, Passwort und Kontoverwaltung',
    help_faq: 'Häufig gestellte Fragen',
    help_s_faq: 'Schnelle Antworten auf häufige Fragen',
    help_nuttig: 'War dieser Artikel hilfreich?',
    help_geen_resultaten: 'Versuchen Sie andere Suchbegriffe',
    help_contact: 'SendWell kontaktieren',
    help_niet_gevonden: 'Antwort nicht gefunden?',
    cht_taart: 'Torte', cht_donut: 'Ring', cht_balk: 'Balken',
    dashboard_welkom_middag: 'Guten Nachmittag',
    dashboard_welkom_avond: 'Guten Abend',
    dashboard_hier_overzicht: 'Hier ist Ihre Übersicht für',
    dashboard_afgerond_dit_jaar: 'Abgeschlossen dieses Jahr',
    verstuur: 'Senden',
    geen_berichten_aanvraag: 'Keine Nachrichten für diese Sendung',
    geen_berichten_nog: 'Noch keine Nachrichten',
    filter_tip: 'Wählen Sie "Allgemein", um alle Nachrichten zu sehen',
    start_gesprek: 'Senden Sie eine Nachricht, um das Gespräch zu beginnen',

    // Analytik erweitert
    analytics_totale_kosten: 'Gesamtkosten',
    analytics_gem_zending: 'Ø pro Sendung',
    analytics_totaal_gewicht: 'Gesamtgewicht',
    analytics_gem_doorlooptijd: 'Ø Durchlaufzeit',
    zendingen_dit_jaar: 'Sendungen dieses Jahr',
    momenteel_onderweg: 'aktuell unterwegs',
    geen_actieve_zendingen: 'Keine aktiven Sendungen',
    gem_per_transport: 'Durchschnitt pro Transport',
    geen_colli_data: 'Keine Paketdaten',
    laad_los_datum: 'Beladedatum → Lieferdatum',
    analytics_geen_kosten: 'Noch keine Kostendaten verfügbar',
    analytics_geen_gewicht: 'Noch keine Gewichtsdaten verfügbar',
    gewicht_per_maand: 'Gewicht pro Monat (kg)',
    analytics_op_losland: 'Basierend auf Lieferland',
    analytics_laad_los_combo: 'Lade → Entlade-Kombinationen',
    analytics_aantal_bestemming: 'Anzahl pro Ziel',
    analytics_aantal_route: 'Anzahl pro Route',
    analytics_wat_vervoert: 'Was versenden Sie am häufigsten',
    analytisch_categorieren: 'Kategorien',
    periode_maand: 'Monat', periode_kwartaal: 'Quartal', periode_jaar: 'Jahr',
    kleurenpalet: 'Farbpalette',
    pal_oceaan: 'Ozean', pal_zonsondergang: 'Sonnenuntergang',
    pal_bos: 'Wald', pal_paars: 'Lila', pal_contrast: 'Hoher Kontrast',
    maand_jan: 'Jan', maand_feb: 'Feb', maand_mrt: 'Mär', maand_apr: 'Apr',
    maand_mei: 'Mai', maand_jun: 'Jun', maand_jul: 'Jul', maand_aug: 'Aug',
    maand_sep: 'Sep', maand_okt: 'Okt', maand_nov: 'Nov', maand_dec: 'Dez',

    // Dashboard
    wacht_op_bevestiging: 'Warte auf Bestätigung',
    geen_facturen_gevonden: 'Keine Rechnungen gefunden',
    logistiek: 'Logistik', administratie: 'Verwaltung',
    communicatie_sub: 'Direkte Kommunikation mit SendWell',
    help_sub: 'Antworten auf häufig gestellte Fragen',
    lopende_aanvragen: 'Aktive Sendungen',
    soort: 'Typ', reden: 'Grund',

  },

  fr: {
    nav_dashboard: 'Tableau de bord',
    nav_aanvragen: 'Expéditions',
    nav_tracking: 'Suivi en direct',
    nav_analytics: 'Analytique',
    nav_facturen: 'Factures',
    nav_bordero: 'Dossier',
    nav_berichten: 'Messages',
    nav_help: 'Aide',
    nav_instellingen: 'Paramètres',
    nav_afdrukken: 'Imprimer',
    nav_uitloggen: 'Déconnexion',

    portaalgebruiker: 'Utilisateur portail',
    nieuwe_aanvraag: 'Nouvelle expédition',
    transport_inplannen: 'Planifier transport',
    laden: 'Chargement...',
    opslaan: 'Enregistrer',
    annuleren: 'Annuler',
    sluiten: 'Fermer',
    bewerken: 'Modifier',
    verwijderen: 'Supprimer',
    downloaden: 'Télécharger',
    zoeken: 'Rechercher...',
    alles_gelezen: 'Tout marquer lu',
    geen_resultaten: 'Aucun résultat',
    terug: '← Retour',

    status_aanvraag_ingediend: 'Demande soumise',
    status_prijs_ontvangen: 'Prix reçu',
    status_prijs_geoffreerd: 'Prix proposé',
    status_akkoord_gegeven: 'Approuvé',
    status_opdracht_ontvangen: 'Commande reçue',
    status_opdracht_verzonden: 'Commande envoyée',
    status_opdracht_bevestigd: 'Commande confirmée',
    status_onderweg: 'En transit',
    status_afgeleverd: 'Livré',
    status_afgerond: 'Terminé',
    status_factuur_verstuurd: 'Facture envoyée',
    status_betaald: 'Payé',
    status_geannuleerd: 'Annulé',
    status_in_behandeling: 'En cours',
    alle_statussen: 'Tous les statuts',

    dashboard_welkom: 'Bonjour',
    dashboard_actieve_zendingen: 'Expéditions actives',
    dashboard_onderweg: 'en transit',
    dashboard_openstaande_facturen: 'Factures en attente',
    dashboard_ongelezen_berichten: 'Messages non lus',
    dashboard_recente_activiteit: 'Activité récente',
    dashboard_alles_in_orde: 'Tout est en ordre',
    dashboard_kosten_routes: 'Coûts & routes',

    aanvraag: 'Expédition',
    aanvragen_overzicht: 'Aperçu de tous vos ordres de transport',
    datum: 'Date',
    bestemming: 'Destination',
    goederen: 'Marchandises',
    laaddatum: 'Date de chargement',
    losdatum: 'Date de livraison',
    status: 'Statut',
    actie: 'Action',
    route: 'Route',
    prijs: 'Prix',
    totaal: 'Total',
    klant: 'Client',
    onbekend: 'Inconnu',
    hub_bereikt: 'Hub atteint',
    hub_verlaten: 'Hub quitté',

    facturen_overzicht: 'Aperçu financier de votre compte',
    factuurnr: 'N° facture',
    factuurdatum: 'Date facture',
    vervaldatum: 'Date échéance',
    openstaand: 'En attente',
    betaald: 'Payé',
    factuur_niet_beschikbaar: 'Facture PDF non disponible.',
    fout_ophalen_factuur: 'Erreur lors de la récupération de la facture.',
    facturen: 'factures',
    facturen_weergegeven: 'factures affichées',
    verloopt_over: 'Échéance dans',
    dgn: 'jours',
    te_laat: 'jours de retard',

    zendingdossier: 'Dossier d\'expédition',
    tijdlijn: 'Chronologie',
    route_gps: 'Route & GPS',
    communicatie: 'Communication',
    documenten: 'Documents',
    factuur: 'Facture',
    geen_tracker: 'Aucun tracker lié à cette expédition.',
    geen_gps: 'Aucune position GPS disponible.',
    gps_laden: 'Chargement GPS...',
    dossier_laden: 'Chargement du dossier...',
    geen_events: 'Aucun événement enregistré pour cette expédition.',
    geen_bijlagen: 'Aucune pièce jointe disponible pour cette expédition.',
    geen_communicatie: 'Aucune communication trouvée pour cette expédition.',
    geen_documenten: 'Aucun document disponible pour cette expédition.',
    geen_factuur: 'Aucune facture disponible pour cette expédition.',
    afdrukken: 'Imprimer',
    verversen: 'Actualiser',
    huidige_positie: 'Position actuelle',
    zendingdossiers: 'Dossiers d\'expédition',
    zendingdossiers_sub: 'Historique complet, documents et chronologie par expédition',
    proof_of_delivery: 'Preuve de livraison',
    succesvol_afgeleverd: '✓ Expédition livrée avec succès',
    cmr_document: 'Lettre de voiture CMR',

    live_tracking: 'Suivi en direct',
    actieve_zendingen: 'expéditions actives',
    zendingen: 'Expéditions',
    klik_op_kaart: 'Cliquer sur la carte pour afficher',
    alle_bestemmingen: 'Toutes destinations',
    laatste_update: 'Dernière mise à jour',
    meer_info: '▼ Plus d\'info',
    minder_info: '▲ Moins d\'info',
    live: 'EN DIRECT',

    nieuw_bericht: 'Nouveau message',
    klik_om_te_lezen: 'Cliquer pour lire',

    instellingen: 'Paramètres',
    bedrijfslogo: 'Logo entreprise pour documents',
    logo_sub: 'Ce logo apparaît sur tous les documents et rapports imprimés.',
    logo_uploaden: 'Télécharger logo',
    ander_logo: 'Choisir autre logo',
    logo_opgeslagen: '✓ Logo enregistré — visible sur tous les documents',
    nog_geen_logo: 'Aucun logo téléchargé',
    account: 'Compte',
    gebruikersnaam: 'Nom d\'utilisateur',
    wachtwoord_wijzigen: 'Changer mot de passe',
    huidig_wachtwoord: 'Mot de passe actuel',
    nieuw_wachtwoord: 'Nouveau mot de passe',
    bevestig_wachtwoord: 'Confirmer mot de passe',

    login_welkom: 'Bienvenue sur le portail client SendWell',
    login_sub: 'Connectez-vous pour gérer vos expéditions',
    inloggen: 'Se connecter',
    inloggen_bezig: 'Connexion...',

    taal: 'Langue',
    taal_nl: 'Néerlandais',
    taal_en: 'Anglais',
    taal_de: 'Allemand',
    taal_fr: 'Français',
    login_gebruikersnaam: 'Votre nom d\'utilisateur',
    login_wachtwoord: 'Mot de passe',
    login_onthoud: 'Se souvenir de moi',
    login_contact: 'Nous contacter',
    login_admin: '← Retour connexion admin',
    klanten_portal: 'Portail client',
    laadplaats: 'Lieu de chargement',
    losplaats: 'Lieu de livraison',
    aanvraagdatum: 'Date de demande',
    factuurnummer: 'Numéro de facture',
    referentie: 'Référence',
    opmerkingen: 'Remarques',
    specialiteiten: 'Exigences spéciales',
    overzicht: 'Aperçu',
    tracker: 'Tracker',
    geen_goederen: 'Aucune marchandise spécifiée',
    klik_factuur: 'Cliquer pour voir la facture',
    prijs_excl_btw: 'Prix (hors TVA)',
    akkoord_geven: 'Approuver',
    kopieer_aanvraag: 'Copier la demande',
    geen_aanvragen: 'Aucune expédition trouvée',
    klik_details: 'Cliquer pour les détails',
    aantal: 'Quantité',
    omschrijving: 'Description',
    gewicht: 'Poids',
    afmetingen: 'Dimensions',
    lossen: 'Déchargement',
    bezig: 'En cours...',
    berichten_titel: 'Messages',
    chat_team: 'Discutez avec notre équipe',
    typ_bericht: 'Tapez un message... (Entrée pour envoyer)',
    foto_toevoegen: 'Ajouter photo',
    online: 'En ligne',
    algemeen: 'Général',
    betreft: 'Objet:',
    analytics_titel: 'Analytique',
    nog_geen_data: 'Aucune donnée disponible',
    status_zendingen: 'Statut de toutes les expéditions',
    zendingen_per_land: 'Expéditions par pays',
    kosten_route: 'Coûts par route',
    kosten_bestemming: 'Coûts par destination',
    meest_routes: 'Routes les plus utilisées',
    goederensoorten: 'Types de marchandises',
    kostenverdeling: '💰 Répartition des coûts',
    trends_periode: '📈 Tendances par période',
    volumeverdeling: '📦 Répartition des volumes',
    status_gewicht: '🔄 Statut et poids',
    basis_gegevens: 'Données de base',
    overige_gegevens: 'Autres données',
    factuuradres: 'Adresse de facturation',
    bedrijfsnaam: 'Nom de l\'entreprise',
    adres: 'Adresse',
    postcode: 'Code postal',
    plaats: 'Ville',
    land: 'Pays',
    telefoon: 'Téléphone',
    website: 'Site web',
    contactpersoon: 'Personne de contact',
    rekeningnummer: 'Numéro de compte',
    kvk_nr: 'N° de registre',
    btw_nr: 'N° TVA',
    btw_tarief: 'Taux TVA',
    bewerkmodus: 'Mode édition actif',
    herhaal_wachtwoord: 'Répéter mot de passe',
    min_8_chars: 'Min. 8 caractères',
    prijsopgave: 'Devis',
    prijs_niet_beschikbaar: 'Prix pas encore disponible',
    ontvangen_door: 'Reçu par',
    cmr_nummer: 'Numéro CMR',

    // Berichten
    gisteren: 'Hier',
    nav_vaste_zendingen: 'Expéditions fixes',
    herhaal: 'Répéter', herhaal_zending: "Répéter l'expédition",
    herhaal_prefilled: "Pré-rempli sur la base d'une expédition précédente — ajustez si nécessaire.",
    ja_btn: 'Oui', nee_btn: 'Non',
    help_hero_titel: 'Comment pouvons-nous vous aider?',
    help_hero_sub: 'Parcourez notre base de connaissances ou naviguez par catégories.',
    help_zoek_placeholder: 'Rechercher par sujet...',
    help_bladeren: 'Parcourir par catégorie',
    help_populair: '📌 Articles populaires',
    help_aanvraag: 'Soumettre une demande',
    help_s_aanvraag: 'Comment soumettre une nouvelle demande de transport',
    help_tracking: 'Suivre votre expédition',
    help_s_tracking: 'Suivi GPS en direct et historique des routes',
    help_berichten: 'Messages & communication',
    help_s_berichten: 'Communiquer avec SendWell via le portail',
    help_documenten: 'Documents & factures',
    help_s_documenten: 'Consulter devis, confirmations et factures',
    help_account: 'Votre compte',
    help_s_account: 'Connexion, mot de passe et gestion du compte',
    help_faq: 'Questions fréquentes',
    help_s_faq: 'Réponses rapides aux questions courantes',
    help_nuttig: 'Cet article vous a-t-il été utile?',
    help_geen_resultaten: "Essayez d'autres termes de recherche",
    help_contact: 'Contacter SendWell',
    help_niet_gevonden: 'Réponse introuvable?',
    cht_taart: 'Camembert', cht_donut: 'Anneau', cht_balk: 'Barres',
    dashboard_welkom_middag: 'Bon après-midi',
    dashboard_welkom_avond: 'Bonsoir',
    dashboard_hier_overzicht: 'Voici votre aperçu pour',
    dashboard_afgerond_dit_jaar: 'Terminé cette année',
    verstuur: 'Envoyer',
    geen_berichten_aanvraag: 'Aucun message pour cette expédition',
    geen_berichten_nog: 'Pas encore de messages',
    filter_tip: 'Sélectionnez "Général" pour voir tous les messages',
    start_gesprek: 'Envoyez un message pour démarrer la conversation',

    // Analytique étendu
    analytics_totale_kosten: 'Coûts totaux',
    analytics_gem_zending: 'Moy. par expédition',
    analytics_totaal_gewicht: 'Poids total',
    analytics_gem_doorlooptijd: 'Délai moyen',
    zendingen_dit_jaar: 'expéditions cette année',
    momenteel_onderweg: 'actuellement en transit',
    geen_actieve_zendingen: 'Aucune expédition active',
    gem_per_transport: 'Moyenne par transport',
    geen_colli_data: 'Pas de données colis',
    laad_los_datum: 'Date chargement → date livraison',
    analytics_geen_kosten: 'Pas encore de données de coûts',
    analytics_geen_gewicht: 'Pas encore de données de poids',
    gewicht_per_maand: 'Poids par mois (kg)',
    analytics_op_losland: 'Basé sur le pays de livraison',
    analytics_laad_los_combo: 'Combinaisons chargement → livraison',
    analytics_aantal_bestemming: 'Nombre par destination',
    analytics_aantal_route: 'Nombre par route',
    analytics_wat_vervoert: 'Ce que vous expédiez le plus',
    analytisch_categorieren: 'catégories',
    periode_maand: 'Mois', periode_kwartaal: 'Trimestre', periode_jaar: 'Année',
    kleurenpalet: 'Palette de couleurs',
    pal_oceaan: 'Océan', pal_zonsondergang: 'Coucher de soleil',
    pal_bos: 'Forêt', pal_paars: 'Violet', pal_contrast: 'Contraste élevé',
    maand_jan: 'jan', maand_feb: 'fév', maand_mrt: 'mar', maand_apr: 'avr',
    maand_mei: 'mai', maand_jun: 'juin', maand_jul: 'juil', maand_aug: 'août',
    maand_sep: 'sep', maand_okt: 'oct', maand_nov: 'nov', maand_dec: 'déc',

    // Dashboard
    wacht_op_bevestiging: 'En attente de confirmation',
    geen_facturen_gevonden: 'Aucune facture trouvée',
    logistiek: 'Logistique', administratie: 'Administration',
    communicatie_sub: 'Communication directe avec SendWell',
    help_sub: 'Réponses aux questions fréquemment posées',
    lopende_aanvragen: 'Expéditions en cours',
    soort: 'Type', reden: 'Raison',

  },
};

export default translations;

// Extra sleutels - worden toegevoegd aan elke taal
